import React, {useMemo} from "react";
import logo from "./logo.svg";
import _data from "./data.json";
import "./App.scss";
import {Link, Navigate, useParams} from "react-router-dom";
import classNames from "classnames";
import Page404 from "./Page404";
import ContentPane from "./ContentPane";

const makeId = (label: string) => label.toLowerCase().replace(/ /g, "-");

interface DataEntryL2 {
  name: string;
  src: string;
}

interface DataEntryL1 {
  name: string;
  items: Record<string, DataEntryL2>;
}

const data: Record<string, DataEntryL1> = {};
Object.keys(_data).forEach((key) => {
  data[makeId(key)] = {name: key, items: {}};
  Object.keys((_data as any)[key]).forEach((key2) => {
    data[makeId(key)].items[makeId(key2)] = {name: key2, src: (_data as any)[key][key2]};
  });
});

const firstL1Key = Object.keys(data)[0];

function App() {
  const params = useParams();
  const firstL2Key = useMemo(
    () => (params.navL1 && data[params.navL1] ? Object.keys(data[params.navL1].items)[0] : null),
    [params.navL1]
  );

  const l2Items = useMemo(() => {
    if (!params.navL1 || !data[params.navL1]) return null;
    return data[params.navL1].items;
  }, [params.navL1]);

  if (!params.navL1) return <Navigate to={`/${firstL1Key}`} />;
  if (!data[params.navL1]) return <Page404 />;

  if (!params.navL2) return <Navigate to={`/${makeId(params.navL1 || "")}/${makeId(firstL2Key || "")}`} />;
  if (!data[params.navL1].items[params.navL2]) return <Page404 />;

  return (
    <div className="App">
      <nav>
        <div className="NavBg" />
        <div className="NavContent">
          <img className="Logo" src={logo} alt="logo" />
          <ul className="Menu">
            {Object.keys(data).map((key, i) => {
              return (
                <li key={i} className={classNames({Current: params.navL1 === key})}>
                  <Link to={`/${key}`}>{data[key].name}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>

      <div className="Container">
        <header>
          <ul className="Menu">
            {l2Items &&
              Object.keys(l2Items).map((key, i) => (
                <li key={i} className={classNames({Current: params.navL2 === key})}>
                  {" "}
                  <Link to={`/${params.navL1}/${key}`}>{l2Items[key].name}</Link>
                </li>
              ))}
          </ul>
        </header>
        <ContentPane src={l2Items ? l2Items[params.navL2].src : null} />
      </div>
    </div>
  );
}

export default App;
